import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-chatteardrop",
  "use": "icon-th-chatteardrop-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-chatteardrop\">\n<path d=\"M16.5 3C13.1859 3.00364 10.0086 4.32177 7.66518 6.66518C5.32177 9.0086 4.00364 12.1859 4 15.5V26.0413C4.00066 26.5605 4.20724 27.0584 4.57444 27.4256C4.94163 27.7928 5.43946 27.9993 5.95875 28H16.5C19.8152 28 22.9946 26.683 25.3388 24.3388C27.683 21.9946 29 18.8152 29 15.5C29 12.1848 27.683 9.00537 25.3388 6.66117C22.9946 4.31696 19.8152 3 16.5 3ZM16.5 26H6V15.5C6 13.4233 6.61581 11.3932 7.76957 9.66651C8.92332 7.9398 10.5632 6.59399 12.4818 5.79926C14.4004 5.00454 16.5116 4.79661 18.5484 5.20175C20.5852 5.6069 22.4562 6.60693 23.9246 8.07538C25.3931 9.54383 26.3931 11.4148 26.7982 13.4516C27.2034 15.4884 26.9955 17.5996 26.2007 19.5182C25.406 21.4368 24.0602 23.0767 22.3335 24.2304C20.6068 25.3842 18.5767 26 16.5 26Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-chatteardrop.svg
// module id = E156
// module chunks = 83